import React from "react"
export function DistanceFlag(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g
        id="prefix__distance-flag"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          id="prefix__Flag"
          fill="currentColor"
          d="M5 1l11 6.278-8.556 3.617V18H5z"
        />
      </g>
    </svg>
  )
}
